import React from 'react'
import PropTypes from 'prop-types'
import Image from '../image/image'

import './imageGrid.css'

const ImageGrid = ({ data }) => {
  const columns = data.columns || '2'
  return (
    <section className="imageGrid">
      {data.images.map(img => (
        <Image file={img.image} alt={img.alt} className={'md:w-1/' + columns}></Image>
      ))}
    </section>
  )
}

ImageGrid.propTypes = {
  data: PropTypes.object,
}

export default ImageGrid
